module.exports = __webpack_public_path__ + "img/logo.1019f4fb.png";